/*
 *   File : setp-1.js
 *   Author : https://evoqins.com
 *   Description : User risk score questions - step 1
 *   Integrations : 
 *   Version : 1.0.0
*/


import { useState, useEffect } from "react";
import { Modal } from "bootstrap";
import { toast } from "react-toastify";

// Components
import { PrimaryButton } from "../../Component/Buttons";
import { CustomRadioButton } from "../../Component/Others";
import { APIService } from "../../Service";
import { RiskProfileStatus } from "../../Component/Modal";


function Step1(props) {

  let selected_risk_question_answers = props.questions.map((item) => {
    return {
      "id": item.question_id, // question id
      "question_description": item.question_description,
      "risk_question_options": {
        "id": null,
        "option_weight": null,
        "option_description": null
      }
    }
  });


  // if (props.riskHistoryData.length !== 0 && props.riskHistoryData[0].risk_answers) {
  //   selected_risk_question_answers = props.questions.map((item, index) => {

  //     let risk_history = props.riskHistoryData[index] || {};
  //     let selected_option = item.risk_question_options.find(question => question.option_description === risk_history.risk_answers);
  //     return {
  //       "id": item.id, // question id
  //       "question_description": item.question_description,
  //       "risk_question_options": {
  //         "id": selected_option ? selected_option.id : null,
  //         "option_weight": selected_option ? selected_option.option_weight : null,
  //         "option_description": selected_option ? risk_history.risk_answers : null
  //       }
  //     }

  //   });
  // } else {
  //   selected_risk_question_answers = props.questions.map((item) => {
  //     return {
  //       "id": item.id, // question id
  //       "question_description": item.question_description,
  //       "risk_question_options": {
  //         "id": null,
  //         "option_weight": null,
  //         "option_description": null
  //       }
  //     }
  //   });
  // };

  // const [sliderRange, setSliderRange] = useState(8);
  const [selectedRiskQuestionAnswers, setSelectedRiskQuestionAnswers] = useState(selected_risk_question_answers);
  const [showRiskProfileStatusModal, setShowRiskProfileStatusModal] = useState(false);
  const [riskData, setRiskData] = useState({});
  const [loading, setLoading] = useState(false);
  const [ipAddress, setIPAddress] = useState("");

  useEffect(() => {
    // Getting users IP address pass ===> profile/save-user-risk
    _getIPAddress();

    if (showRiskProfileStatusModal === true) {
      const status_modal = new Modal(document.getElementById('risk-profile-status-modal'));
      status_modal.show();
    }
  }, [showRiskProfileStatusModal]);


  // handle select answer
  const _handleSelect = (data, question_index) => {
    let updated_questions = selectedRiskQuestionAnswers;
    updated_questions[question_index].risk_question_options = {
      "id": data.option_id,
      "option_weight": data.option_weight,
      "option_description": data.option_description
    };

    setSelectedRiskQuestionAnswers([...updated_questions]);
  };

  // handle amount range slider
  // const _handleSliderValueRange = (value) => {
  //   setSliderRange(value);
  // };

  // submit risk questions
  const _handleSubmitQuestions = () => {

    // Validating answers
    let is_valid = selectedRiskQuestionAnswers.every(item => item.risk_question_options.id !== null);

    if (is_valid) {
      // Make API call
      setLoading(true);
      _calculateRiskScore();
    } else {
      toast.dismiss();
      toast.error("Please answer to all the questions, to proceed further");
    }

  };

  // Save risk questions and answers
  const _handleContinue = () => {
    setShowRiskProfileStatusModal(false);
    setLoading(true);
    _saveRiskQuestions(riskData.data.risk_category_id, riskData.data.risk_category_name);
  };

  // handle retake risk profile
  const _handleRetake = () => {
    setShowRiskProfileStatusModal(false);
  };


  // ============ Submit Risk questions ============== //
  const _calculateRiskScore = async () => {

    let risk_list = selectedRiskQuestionAnswers.map((item) => {
      return {
        "option_id": Number(item.risk_question_options.id),
        "question_id": Number(item.id),
        "option_weight": Number(item.risk_question_options.option_weight)
      }
    });

    let url = "profile/calculate-risk";
    let data = {
      "tenant_id": props.tenantID,
      "basket_risk_id": Number(props.basketRiskInfo.risk_category_id),
      "list": risk_list
    };

    const response = await APIService(url, data);
    if (response.status_code === 200) {
      setRiskData(response);
      setShowRiskProfileStatusModal(true);
      setLoading(false);
    } else {
      toast.dismiss();
      toast.error("Something went wrong please try again after some time");
      setLoading(false);
    }


  };

  // ============ Submit Risk questions ============== //
  const _saveRiskQuestions = async (risk_id, risk_name) => {

    let url = "profile/save-user-risk";
    let risk_questions = selectedRiskQuestionAnswers.map((item) => {
      return {
        "risk_questions": item.question_description,
        "risk_answers": item.risk_question_options.option_description
      }
    });
    let data = {
      "ip_address": ipAddress,
      "tenant_id": props.tenantID,
      "user_id": props.userID,
      "user_risk_id": Number(risk_id),
      "user_risk_name": risk_name,
      "strategy_id": props.strategyID,
      "user_risk_history_request": risk_questions
    };

    const response = await APIService(url, data);
    if (response.status_code === 200) {
      props.handleOnSuccess();
    } else {
      toast.dismiss();
      toast.error(response.message);
    }
    setLoading(false);
  };

  // get IP Address of device
  const _getIPAddress = async () => {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    setIPAddress(data.ip);
  };


  return (
    <div className="p-3">
      <div className="d-flex flex-column gap-4">
        {
          props.questions.map((question, question_index) => (
            <div key={question_index}>
              <h6 className="mb-3 e-text-chinese-black e-alt-font-lato e-font-weight-600 e-font-16 line-height-20px e-letter-spacing-min-point-1px">
                {question.question_description}
              </h6>
              <div className="d-flex gap-12px flex-column">
                {
                  question.options_info.map((data, option_index) => (
                    <CustomRadioButton data={data}
                      type={2}
                      key={option_index}
                      selected={selectedRiskQuestionAnswers[question_index].risk_question_options.option_description}
                      handleSelect={(data) => _handleSelect(data, question_index)} />
                  ))
                }
              </div>
            </div>
          ))
        }
      </div>

      <PrimaryButton name="Submit Questions"
        status={loading}
        disabled={loading}
        className="w-100 h-48 e-letter-spacing-min-point-1px col-9 my-5"
        icon={false}
        fontSize="e-font-16"
        onPress={_handleSubmitQuestions} />


      {/* Risk Profile Mismatch status modal */}
      {
        showRiskProfileStatusModal &&
        <RiskProfileStatus data={props}
          riskData={riskData.data}
          type={riskData.show_retake ? 2 : 1}
          basketName={props.basketName}
          basketRiskInfo={props.basketRiskInfo}
          handleContinue={_handleContinue}
          handleRetake={_handleRetake} />
      }

    </div>


  )
}

export default Step1